import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "a4-page",
  style: {"position":"relative","background-color":"var(--color-white)","border":"1px solid var(--color-light-gray)","box-shadow":"0 2px 8px rgba(0, 0, 0, 0.1)","width":"100%","aspect-ratio":"1/1.414","padding":"40px","overflow":"hidden"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_monthly_coverage_section = _resolveComponent("monthly-coverage-section")!
  const _component_price_section = _resolveComponent("price-section")!
  const _component_date_signature_section = _resolveComponent("date-signature-section")!
  const _component_report_footer = _resolveComponent("report-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.shouldShowMonthlyCoverage)
      ? (_openBlock(), _createBlock(_component_monthly_coverage_section, {
          key: 0,
          "project-data": _ctx.projectData,
          "include-sections": _ctx.includeSections,
          "payment-type": _ctx.paymentType,
          "report-type": _ctx.reportType
        }, null, 8, ["project-data", "include-sections", "payment-type", "report-type"]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowPrice)
      ? (_openBlock(), _createBlock(_component_price_section, {
          key: 1,
          "project-data": _ctx.projectData,
          "payment-type": _ctx.paymentType,
          "report-type": _ctx.reportType
        }, null, 8, ["project-data", "payment-type", "report-type"]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowSignature)
      ? (_openBlock(), _createBlock(_component_date_signature_section, {
          key: 2,
          "report-type": _ctx.reportType
        }, null, 8, ["report-type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_report_footer, { "report-type": _ctx.reportType }, null, 8, ["report-type"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "position-absolute bottom-0 end-0",
      style: {"padding":"20px 40px"}
    }, [
      _createElementVNode("small", {
        class: "text-muted",
        style: {"font-size":"12px"}
      }, "3")
    ], -1))
  ]))
}